import { BadgeCheck } from "lucide-react";
import { cn } from "../lib/cn";

export function KYCBadge({
  size = "md",
  label,
  className,
}: {
  size?: "sm" | "md" | "lg";
  label?: string;
  className?: string;
}) {
  const sizeMap = {
    sm: "h-4 w-4",
    md: "h-5 w-5",
    lg: "h-6 w-6",
  };
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1 rounded-full bg-trust-500/20 px-2 py-0.5 text-trust-500",
        "text-xs font-medium",
        className,
      )}
      title="Enhanced KYC 인증된 계정"
    >
      <BadgeCheck className={sizeMap[size]} aria-hidden="true" />
      {label ?? "Verified"}
    </span>
  );
}
